import deviceObserver from './device-observer';

export { deviceObserver };